import { render, staticRenderFns } from "./ed-folder-item.component.vue?vue&type=template&id=54a17dae&scoped=true&"
import script from "./ed-folder-item.component.ts?vue&type=script&lang=ts&"
export * from "./ed-folder-item.component.ts?vue&type=script&lang=ts&"
import style0 from "./ed-folder-item.component.scss?vue&type=style&index=0&id=54a17dae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a17dae",
  null
  
)

export default component.exports